import "./listing_compare_card.css";
